import AssessmentManager from "../assessment/assessment-manager";
import RenderManager from "../rendering/render-manager";
import { meshRaycaster, updateAutoCenterHelperPosition } from "./add-interactivity";
import getRelativeCoordinates from "../utils/get-relative-coordinates";
import { isCameraOrbitTempActive } from '../utils/object-rotation-controls/camera-orbit-toggle';

class Mouse {
    constructor() {
        this._position = new THREE.Vector2();
        this._which = Object.seal({
            left: false,
            right: false
        });

        document.addEventListener("mousedown", onMouseDown.bind(this));
        document.addEventListener("mouseup", onMouseUp.bind(this));
        document.addEventListener("touchstart", onTouchStart.bind(this));
        document.addEventListener("touchend", onTouchEnd.bind(this));
    }

    get which() { return this._which; }
    get isDown() { return this._which.left || this._which.right; }
    get position() { return this._position; }

    updateMouseState({ event, value } = {}) {
        if (event) {
            switch (event.button) {
                case 0:
                    this._which.left = value;
                    break;
                case 2:
                    this._which.right = value;
                    break;
            }
        }

        if (this._which.right) { updateTarget(); }

        return this;
    }
}

export default Mouse;
export { Mouse };

function onMouseDown(event) {
    switch (event.button) {
        case 0:
            this._which.left = true;
            break;
        case 2:
            this._which.right = true;
            break;
    }
}

function onMouseUp(event) {
    if (!Q3.controls) return;
    switch (event.button) {
        case 0:
            this._which.left = false;
            break;
        case 2:
            this._which.right = false;
            break;
    }

    if (!Q3.controls.tweening
        && !AssessmentManager.inAssessmentMode
        && Q3.data.slides[Q3.SlideManager.activeSlide].camera.disabled !== true
        && !isCameraOrbitTempActive())
        Q3.controls.enabled = true;
}

function onTouchStart(event) {
    this._which.left = true;

    let pos = getRelativeCoordinates(event);

    this.updateMouseState();

    const posScreenspace = RenderManager.toScreenSpaceCoords(pos);

    this._position.copy(posScreenspace);
}

function onTouchEnd() { this._which.left = false; }

const updateTarget = (function () {
    const tmpVec2 = new THREE.Vector2();
    const tmpVec3 = new THREE.Vector3();

    return function () {
        meshRaycaster.setFromCamera(tmpVec2, RenderManager.activeCamera);
        const intersections = meshRaycaster.intersectObject(RenderManager.activeScene, true);


        let itsct = null;
        for (let i = 0, len = intersections.length; i < len; i++) {
            const curObject = intersections[i].object;
            if (curObject.visible && !curObject.dontShowInHierarchyPanel && !curObject.isBackground && curObject.isGate) {
                itsct = intersections[i];
                break;
            }
        }

        if (itsct) {
            const dir = RenderManager.activeCamera.getWorldDirection(tmpVec3).multiplyScalar(itsct.distance + 1);

            Q3.controls.target.addVectors(RenderManager.activeCamera.position, dir);

            updateAutoCenterHelperPosition();

            Q3.controls.update();
        }
    }
})();
